export const trailingArrow = {
  content: JSON.stringify('\u2192'),
  paddingLeft: 10,
};
